<template>
  <div class="pt-4">
    <vue-table :data="data" :headers="headers" :loading="loading" @change="onPagination">
      <template v-slot:index="{item}">
        {{ (item.index + 1) + ((data.current_page - 1) * data.per_page) }}
      </template>

      <template v-slot:action="{item}">
        <manage-buttons :data="item" :meta="metaButtons"/>
      </template>
    </vue-table>

    <custom-popup v-model="ch_modal" :cons="{title: 'لیست تاریخچه‌ها'}" hide-confirm reloadable>
      <show-create-history v-if="ch_modal" v-model="editValue"/>
    </custom-popup>
  </div>
</template>

<script>
import manageButtons from "@/view/content/button.vue";
import ShowCreateHistory from "@/view/pages/customers/showCreateHistory.vue";

export default {
  name: "index",

  components: {
    ShowCreateHistory,
    manageButtons
  },

  data() {
    return {
      data: {},
      loading: false,
      headers: [
        {value: 'index', text: 'ردیف', sortable: false, align: 'center'},
        {value: 'name', text: 'نام', sortable: false, align: 'center'},
        {value: 'father_name', text: 'نام پدر', sortable: false, align: 'center'},
        {value: 'national_id', text: 'کدملی', sortable: false, align: 'center'},
        {value: 'mobile', text: 'شماره موبایل', sortable: false, align: 'center'},
        {value: 'action', text: 'مدیریت', sortable: false, align: 'center'},
      ],
      tableProps: {
        length: 10,
        page: 1
      },
      metaButtons: {
        buttons: [
          {
            name: 'delete',
            label: 'حذف',
            icon: 'trash-alt',
            class: 'btn-outline-danger rounded-pill',
            action: this.actions,
          },
          {
            name: 'edit',
            label: 'ویرایش اطلاعات',
            icon: 'edit',
            class: 'btn-outline-warning rounded-pill',
            action: this.actions,
          },
          {
            name: 'history',
            label: 'ایجاد تاریخچه',
            icon: 'history',
            class: 'btn-outline-success rounded-pill',
            action: this.actions,
          },
        ]
      },
      ch_modal: false,
      editValue: null
    }
  },

  mounted() {
    this.fetch()
  },

  methods: {
    fetch(params = this.tableProps) {
      this.loading = true

      this.requestApiGetState('user/customer', params)
        .then(({data}) => this.data = data.data)
        .catch(({response}) => console.log('failed to get user customers list: ', response))
        .finally(() => this.loading = false)
    },
    onPagination(e) {
      let props = {
        ...this.tableProps,
        ...e
      }

      this.fetch(props)
    },
    actions(data, type) {
      this[type](data);
    },
    history(data) {
      this.editValue = data

      this.$nextTick(() => {
        this.ch_modal = true
      })
    }
  }
}
</script>

<style scoped>

</style>